import { platformRead } from './http'

// 仅使用平台登录身份；不接受设备清单或自定义权限过滤。服务端重新核对产品下的可见设备。
export const queryChargingStatistics = (productId, options = {}) => {
  if (typeof productId !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(productId)) return Promise.reject(new Error('请选择有效的充电桩产品'))
  const { pageId, componentId, ...transport } = options
  if ((pageId || componentId) && (!/^[A-Za-z0-9_-]{1,64}$/.test(pageId || '') || !/^[A-Za-z0-9_-]{1,64}$/.test(componentId || ''))) return Promise.reject(new Error('统计页面或组件编号无效'))
  return platformRead({ method: 'post', url: '/jetlinks/visualization/charging-statistics/_query', data: { productId, ...(pageId && componentId ? { pageId, componentId } : {}) } }, pageId || componentId ? transport : options)
}

// 返回值只作展示适配；null 保留为数据缺口，不替换成演示值或零。
export function chargingStatisticsChart (snapshot, name) {
  const result = snapshot && snapshot.charts && snapshot.charts[name]
  if (Array.isArray(result)) return result.map(item => ({ name: item.name, value: item.value }))
  if (!result || !Array.isArray(result.categories) || !Array.isArray(result.series)) return { categories: [], series: [] }
  return { categories: result.categories.slice(), series: result.series.map(item => ({ name: item.name, data: item.data.slice() })) }
}
